import { Record, Set } from 'immutable';

export const EventsFactory = new Record({
  eventHash: '',
  nextNumPage: undefined,
  countOfNewEvents: 0,
  list: new Set(),
  isOpened: false,
});

const EventsCompanChatFactory = new Record({
  type: 'company_chat',
  channel_name: '',
  channel_url: '',
  companyID: '',
});

const EventsDocumentChatFactory = new Record({
  type: 'document_chat',
  channel_name: '',
  channel_url: '',
  companyID: '',
  documentID: '',
});

const EventsDocumentFactory = new Record({
  type: 'document',
  documentID: '',
  exist: true,
});

const EventsLinkedFactory = new Record({
  type: 'linked_document',
  linkID: '',
  confidential: false,
  rootCategory: 30,
});

export const EventsItemFactory = new Record({
  id: '',
  timestamp: 0,
  userID: '',
  username: '',
  documentID: '',
  message: '',
  details: '',
  link: null,
});

// eslint-disable-next-line max-len
export function EventsItemAdapter({ link, ...rest }) {
  if (link.type === 'document') {
    return EventsItemFactory({ link: EventsDocumentFactory(link.source), ...rest });
  }
  if (link.type === 'linked_document') {
    return EventsItemFactory({ link: EventsLinkedFactory(link.source), ...rest });
  }
  if (link.type === 'company_chat') {
    return EventsItemFactory({ link: EventsCompanChatFactory(link.source), ...rest });
  }
  if (link.type === 'document_chat') {
    return EventsItemFactory({ link: EventsDocumentChatFactory(link.source), ...rest });
  }
  return EventsItemFactory(rest);
}

export function eventsStateAdapter({ data, ...rest }) {
  const list = Set(data.map((e) => EventsItemAdapter(e)));
  return EventsFactory({ ...rest, list });
}
